<template>
    <Transition name="showModal">
        <div
            class="fav-modal display-flex-center"
            @click="$emit('closeModal')"
            v-show="isShowFavModal"
            @keyup.esc="$emit('closeModal')"
        >
            <div class="fav-modal__wrapper" @click="handleContent($event)">
                <div
                    class="fav-modal__close-wrapper"
                    :class="
                        isMobile ? 'display-flex-center' : 'display-flex-fe'
                    "
                    v-if="!isMobile"
                >
                    <div @click="$emit('closeModal')" class="pointer">
                        <SvgIcon icon="popup.close.icon"></SvgIcon>
                    </div>
                    <!-- <div class="fav-modal__close" @click="$emit('closeModal')"></div> -->
                    <div class="fav-modal__close-title" v-show="isMobile">
                        {{ $t("SEARCH") }}
                    </div>
                </div>
                <div class="fav-modal__inner-wrapper">
                    <!-- Search Box -->
                    <div
                        v-show="!country.isShowCountryListOnly"
                        class="search-wrapper"
                    >
                        <IconMode>
                            <template #default="{ index }">
                                <img
                                    src="@static/images/icons/aspn_icon/icon_search.png"
                                    v-if="index === 'lightWeb'"
                                    class="search-icon"
                                />
                                <img
                                    src="@static/images/icons/aspn_icon/icon_search.png"
                                    v-else-if="index === 'darkWeb'"
                                    class="search-icon"
                                />
                                <img
                                    src="@static/images/icons/aspn_icon/icon_search_filter_webapp.png"
                                    v-else-if="index === 'lightWebapp'"
                                    class="search-icon"
                                />
                                <img
                                    src="@static/images/icons/aspn_icon/icon_search_filter_webapp_dark.png"
                                    v-else-if="index === 'darkWebapp'"
                                    class="search-icon"
                                />
                            </template>
                        </IconMode>
                        <input
                            class="search-input"
                            type="text"
                            :placeholder="$t('SEARCH')"
                            v-model="userInput"
                            @input="handleSearchUserInput"
                            ref="userInputRef"
                        />
                        <div
                            class="close-text"
                            @click="$emit('closeModal')"
                            v-if="isMobile"
                        >
                            {{ $t("CLOSE") }}
                        </div>
                        <!-- <div class="search-clear display-flex-center"  @click="handleClearUserInput">            
							<svg
								width="11"
								height="10"
								viewBox="0 0 11 10"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M10.2992 1.16705L9.33236 0.200195L5.49922 4.03334L1.66608 0.200195L0.699219 1.16705L4.53236 5.0002L0.699219 8.83334L1.66608 9.80019L5.49922 5.96705L9.33236 9.80019L10.2992 8.83334L6.46608 5.0002L10.2992 1.16705Z"
									fill="#E7ECEE"
								/>
							</svg>
						</div> -->
                    </div>
                    <div
                        v-if="country.isShowCountryListOnly"
                        class="fav-modal__subtitle subtitle-countryOnly"
                    >
                        <div
                            class="display-flex-fs pointer"
                            @click="handleCountryGoBack"
                        >
                            <!-- <div class="fav-model__back">
								<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M7.41016 2.01437L2.83016 6.60437L7.41016 11.1944L6.00016 12.6044L0.00015614 6.60437L6.00016 0.60437L7.41016 2.01437Z" fill="white"/>
								</svg>
							</div> -->
                            <div class="mr-05rem">
                                <SvgIcon icon="sign.arrow.left" />
                            </div>
                            <div>{{ country.currentCountryDisplay }}</div>
                        </div>
                    </div>
                    <template v-else>
                        <div
                            class="tab-list"
                            v-show="
                                ![
                                    'footballFavMatches',
                                    'basketballFavMatches',
                                    'footballFavTeams',
                                    'basketballFavTeams',
                                    'footballFavCompetitions',
                                    'basketballFavCompetitions',
                                    'footballFavPlayers',
                                    'basketballFavPlayers',
                                ].includes($route.name)
                            "
                        >
                            <div
                                class="tab-item"
                                v-for="(item, index) in tabs"
                                :key="index"
                                :class="{ selected: item.selected }"
                                @click="selectTab(item, tabs)"
                            >
                                {{ $t(item.name) }}
                            </div>
                        </div>
                    </template>
                    <!-- {{ isNoData }} -->

                    <template v-if="isLoading || isSearching">
                        <div class="loading-box" v-if="!isMobile">
                            <LoadingAspn />
                        </div>
                        <LoadingAspn type="filter" v-else />
                    </template>
                    <div
                        v-else
                        class="fav-modal__wrapper-list"
                        ref="favContentListRef"
                        @scroll="handleFavContentScrollEvent($event)"
                        :class="{ 'scrollbar-show': !isMobile }"
                    >
                        <div :class="{}">
                            <div
                                class="display-flex flex-col"
                                v-if="
                                    countryResult && countryResult.result.length
                                "
                            >
                                <div class="fav-modal__subtitle">
                                    <p>{{ $t("COUNTRY") }}</p>
                                </div>
                                <div
                                    class="fav-modal__modal-card-wrapper fix-h display-flex flex-col"
                                >
                                    <FavCard
                                        v-for="c in countryResult.result"
                                        :key="c.id"
                                        :keyName="c.key"
                                        type="COUNTRY"
                                        :name="c.name"
                                        :id="c.id"
                                        :logo="c.logo"
                                        :isFav="c.isFav"
                                        :subtitle="c.subtitle"
                                        :object="c"
                                        @favHandler="favHandler"
                                        @pageIsRedirected="pageIsRedirected"
                                    />
                                </div>
                            </div>
                            <template v-if="tabName === 'FILTER'">
                                <div
                                    class="display-flex flex-col fav-filter-container-box"
                                    v-for="(o, index) in filterPopularList"
                                    :key="index"
                                >
                                    <div
                                        v-if="!country.isShowCountryListOnly"
                                        class="fav-modal__subtitle"
                                    >
                                        <p>{{ $t(o.title) }}</p>
                                    </div>
                                    <div
                                        v-show="isNoCompetitionDataFromCountry"
                                    >
                                        <div class="display-flex flex-col">
                                            <div class="fav-modal__subtitle">
                                                <p>{{ $t("NO_RESULT") }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="fav-modal__modal-card-wrapper fix-h display-flex flex-col"
                                    >
                                        <FavCard
                                            v-for="c in o.list"
                                            :key="c.id"
                                            :keyName="c.key"
                                            :type="
                                                country.isShowCountryListOnly
                                                    ? 'COMPETITIONS'
                                                    : o.titleType
                                            "
                                            :name="c.name"
                                            :countryKey="c.countryKey"
                                            :id="c.id"
                                            :logo="c.logo"
                                            :isFav="c.isFav"
                                            :titleType="o.titleType"
                                            :subtitle="c.subtitle"
                                            :object="c"
                                            :isShowCompetionFromCountry="
                                                country.isShowCountryListOnly
                                            "
                                            @favHandler="favHandler"
                                            @pageIsRedirected="pageIsRedirected"
                                        />
                                    </div>
                                </div>
                            </template>

                            <div v-else class="display-flex flex-col">
                                <div
                                    class="fav-modal__subtitle"
                                    v-if="!country.isShowCountryListOnly"
                                    v-show="!isNoCompetitionData"
                                >
                                    <p>
                                        {{
                                            !userInput
                                                ? $t(`POPULAR_${tabName}`)
                                                : $t(tabName)
                                        }}
                                    </p>
                                </div>
                                <div v-show="isNoCompetitionDataFromCountry">
                                    <div class="display-flex flex-col">
                                        <div class="fav-modal__subtitle">
                                            <p>{{ $t("NO_RESULT") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="fav-modal__modal-card-wrapper fix-h display-flex flex-col"
                                >
                                    <FavCard
                                        v-for="c in result.result"
                                        :key="c.id"
                                        :keyName="c.key"
                                        :type="tabName"
                                        :countryKey="c.countryKey"
                                        :name="c.name"
                                        :id="c.id"
                                        :logo="c.logo"
                                        :isFav="c.isFav"
                                        :object="c"
                                        @favHandler="favHandler"
                                        @pageIsRedirected="pageIsRedirected"
                                    />
                                </div>
                            </div>
                        </div>
                        <NoData v-if="isNoData" />
                    </div>
                </div>
                <!-- <div class="fav-modal__btn-wrapper display-flex-center" v-show="isMobile">
        	<button class="fav-modal__btn" @click="$emit('closeModal')">{{ $t('DONE') }}</button>
        </div> -->
            </div>
        </div>
    </Transition>
    <PopUpSignInIndexMobile
        ref="PopUpSignInIndexMobileRef"
        :message="$i18n.t('FAV_LOGIN_TIPS')"
    ></PopUpSignInIndexMobile>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FavCard from "./FavCard.vue";
import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";

export default {
    props: ["tabName"],
    components: {
        FavCard,
        PopUpSignInIndexMobile,
    },
    data() {
        return {
            result: "",
            countryResult: "",
            userInput: "",

            isNoData: false,
            showModalTransition: false,
            globalPopularList: [],

            country: {
                isShowCountryListOnly: false,
                currentCountryDisplay: "",
            },

            isReadyToShowData: false,
            isNoCompetitionDataFromCountry: false,
            isNoCompetitionData: false,
            isSearching: false,
            isLoading: false,
            tabs: [
                {
                    name: "ALL",
                    selected: true,
                },
                {
                    name: "COMPETITIONS",
                    selected: false,
                },
                {
                    name: "TEAMS",

                    selected: false,
                },
                {
                    name: "PLAYERS",
                    selected: false,
                },
            ],
            tabsSelected: "ALL",
        };
    },
    watch: {
        isShowFavModal: {
            immediate: true,
            handler(newVal) {
                newVal
                    ? (document.body.style.overflow = "hidden")
                    : (document.body.style.overflow = "unset");

                if (newVal) {
                    this.userInput = "";
                    this.globalPopularList = [];
                    this.result = "";
                    this.countryResult = "";
                    this.getPopularData();
                }

                if (this.$refs.userInputRef) {
                    if (newVal) {
                        this.$nextTick(() => {
                            this.$refs.userInputRef.focus();
                        });
                    } else {
                        this.$refs.userInputRef.blur();
                    }
                }
            },
        },
    },
    computed: {
        ...mapGetters([
            "isLogin",
            "userInfo",
            "isMobile",
            "isShowFavModal",
            "currentSportType",
        ]),
        filterPopularList() {
            const type = this.tabsSelected;
            const list = this.globalPopularList;
            if (type === "ALL") {
                return list;
            } else if (type === "COMPETITIONS") {
                let titleType = "COMPETITIONS";
                for (var i in list) {
                    if (list[i].titleType === titleType) {
                        return [list[i]];
                    }
                }
            } else if (type === "TEAMS") {
                let titleType = "TEAMS";
                for (var i in list) {
                    if (list[i].titleType === titleType) {
                        return [list[i]];
                    }
                }
            } else if (type === "PLAYERS") {
                let titleType = "PLAYERS";
                for (var i in list) {
                    if (list[i].titleType === titleType) {
                        return [list[i]];
                    }
                }
            }
        },
        isNoDataForSelfTab() {
            // console.log(this.isNoData, this.globalPopularList)
            // if(this.isNoData) {
            let list = this.globalPopularList;
            if (this.tabsSelected === "ALL") {
                if (list.length === 0) {
                    return true;
                }
                return false;
            } else {
                if (list.length !== 0) {
                    for (var index in list) {
                        if (list[index].titleType === this.tabsSelected) {
                            return false;
                        }
                    }
                    return true;
                } else {
                    return true;
                }
            }

            // return false
        },
    },
    methods: {
        ...mapActions([
            "getTeamPopular",
            "getCompetitionPopular",
            "getPlayerPopular",
            "getTeamSearch",
            "getCompetitionSearch",
            "getPlayerSearch",
            "getGlobalSearch",
            "getCountrySearch",
            "addFavTeam",
            "addFavLeague",
            "unFavTeam",
            "unFavLeague",
            "toastrFavChangeEvent",
            "getFavGlobalPopular",
            "favLoginTipsChangeEvent",
            "getBasketballCompetitionPopular",
            "getFavBasketballGlobalPopular",
            "getBasketballTeamPopular",
            "getBasketballCountrySearch",
            "getBasketballCompetitionSearch",
            "getBasketballGlobalSearch",
            "getBasketballTeamSearch",
            "unFavBasketballTeam",
            "addFavBasketballTeam",
            "unFavBasketballLeague",
            "addFavBasketballLeague",
        ]),
        getPopularData() {
            this.isLoading = true;
            this.resetCountryDisplay();

            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
                limit: 10,
            };

            this.$nextTick(async () => {
                if (this.tabName === "COMPETITIONS") {
                    if (this.currentSportType == "football")
                        this.result = await this.getCompetitionPopular(params);
                    else if (this.currentSportType == "basketball")
                        this.result =
                            await this.getBasketballCompetitionPopular(params);
                    this.handleEmptyResult(this.result);
                } else if (this.tabName === "PLAYERS") {
                    if (this.currentSportType == "football")
                        this.result = await this.getPlayerPopular(params);
                    else if (this.currentSportType == "basketball")
                        this.result = await this.getBasketballTeamPopular(
                            params
                        );
                    this.handleEmptyResult(this.result);
                } else if (this.tabName === "FILTER") {
                    params.limit = 5;
                    let result;
                    if (this.currentSportType == "football")
                        result = await this.getFavGlobalPopular(params);
                    else if (this.currentSportType == "basketball")
                        result = await this.getFavBasketballGlobalPopular(
                            params
                        );
                    this.globalPopularList = [];

                    this.globalPopularList[0] = {
                        title: "POPULAR_COMPETITIONS",
                        titleType: "COMPETITIONS",
                        list: result.result.competition,
                    };

                    this.globalPopularList[1] = {
                        title: "POPULAR_TEAMS",
                        titleType: "TEAMS",
                        list: result.result.team,
                    };

                    this.globalPopularList[2] = {
                        title: "POPULAR_PLAYERS",
                        titleType: "PLAYERS",
                        list: result.result.player,
                    };

                    this.isNoData = false;
                } else {
                    if (this.currentSportType == "football")
                        this.result = await this.getTeamPopular(params);
                    else if (this.currentSportType == "basketball")
                        this.result = await this.getBasketballTeamPopular(
                            params
                        );
                    this.handleEmptyResult(this.result);
                }

                this.isLoading = false;
            });
        },
        async searchList(input) {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
                q: input,
                limit: 20,
            };

            if (this.tabName === "COMPETITIONS") {
                if (this.currentSportType == "football") {
                    this.countryResult = await this.getCountrySearch(params);
                    this.result = await this.getCompetitionSearch(params);
                } else if (this.currentSportType == "basketball") {
                    this.countryResult = await this.getBasketballCountrySearch(
                        params
                    );
                    this.result = await this.getBasketballCompetitionSearch(
                        params
                    );
                }

                this.resetCountryDisplay();

                if (
                    !this.result.result.length &&
                    !this.countryResult.result.length
                ) {
                    this.isNoData = true;
                } else this.isNoData = false;

                if (this.result.result.length === 0) {
                    this.isNoCompetitionData = true;
                } else {
                    this.isNoCompetitionData = false;
                }
            } else if (this.tabName === "FILTER") {
                let result;
                if (this.currentSportType == "football")
                    result = await this.getGlobalSearch(params);
                else if (this.currentSportType == "basketball")
                    result = await this.getBasketballGlobalSearch(params);

                this.globalPopularList = [];
                if (
                    result.result.country.length === 0 &&
                    result.result.competition.length === 0 &&
                    result.result.team.length === 0 &&
                    result.result.player.length === 0
                ) {
                    this.isNoData = true;
                } else {
                    this.isNoData = false;
                    if (result.result.country.length > 0) {
                        this.globalPopularList.push({
                            title: "COUNTRY",
                            titleType: "COUNTRY",
                            list: result.result.country,
                        });
                    }

                    if (result.result.competition.length > 0) {
                        this.globalPopularList.push({
                            title: "COMPETITIONS",
                            titleType: "COMPETITIONS",
                            list: result.result.competition,
                        });
                    }

                    if (result.result.team.length > 0) {
                        this.globalPopularList.push({
                            title: "TEAMS",
                            titleType: "TEAMS",
                            list: result.result.team,
                        });
                    }

                    if (result.result.player.length > 0) {
                        this.globalPopularList.push({
                            title: "PLAYERS",
                            titleType: "PLAYERS",
                            list: result.result.player,
                        });
                    }
                }

                this.resetCountryDisplay();
            } else if (this.tabName === "PLAYERS") {
                if (this.currentSportType == "football")
                    this.result = await this.getPlayerSearch(params);
                else if (this.currentSportType == "basketball")
                    this.result = await this.getBasketballTeamSearch(params);

                this.isReadyToShowData = true;
                if (!this.result.result.length) {
                    this.isNoData = true;
                } else this.isNoData = false;
            } else {
                if (this.currentSportType == "football")
                    this.result = await this.getTeamSearch(params);
                else if (this.currentSportType == "basketball")
                    this.result = await this.getBasketballTeamSearch(params);

                this.isReadyToShowData = true;
                if (!this.result.result.length) {
                    this.isNoData = true;
                } else this.isNoData = false;
            }
            this.isSearching = false;
        },
        async searchByCountry(id, countryName) {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
                countryId: id,
            };
            let result;

            if (this.currentSportType == "football")
                result = await this.getCompetitionSearch(params);
            else if (this.currentSportType == "basketball")
                result = await this.getBasketballCompetitionSearch(params);

            this.country.isShowCountryListOnly = true;
            this.country.currentCountryDisplay = countryName;

            if (result.result.length === 0) {
                this.isNoCompetitionDataFromCountry = true;
            } else {
                this.isNoCompetitionDataFromCountry = false;
            }

            if (this.tabName === "FILTER") {
                this.globalPopularList = [];

                this.globalPopularList.push({
                    title: "COUNTRY",
                    titleType: "COUNTRY",
                    list: result.result,
                });
            } else if (this.tabName === "COMPETITIONS") {
                this.result = result;
                this.countryResult = "";
            }
        },
        async favHandler(id, isFav, titleType, countryName, type, object) {
            object.isFav = !object.isFav;
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
            };

            if (this.tabName === "TEAMS") {
                params = { ...params, teamId: id };

                let res;
                if (this.currentSportType == "football") {
                    res = isFav
                        ? await this.unFavTeam(params)
                        : await this.addFavTeam(params);
                } else if (this.currentSportType == "basketball") {
                    res = isFav
                        ? await this.unFavBasketballTeam(params)
                        : await this.addFavBasketballTeam(params);
                }

                this.toastrEvent(res, isFav, countryName, id, object);
            } else if (this.tabName === "COMPETITIONS") {
                if (type === "COUNTRY") {
                    this.searchByCountry(id, countryName);
                } else {
                    params = { ...params, leagueId: id };
                    let res;

                    if (this.currentSportType == "football") {
                        res = isFav
                            ? await this.unFavLeague(params)
                            : await this.addFavLeague(params);
                    } else if (this.currentSportType == "basketball") {
                        res = isFav
                            ? await this.unFavBasketballLeague(params)
                            : await this.addFavBasketballLeague(params);
                    }

                    this.toastrEvent(res, isFav, countryName, id, object);
                }
            } else if (this.tabName === "FILTER") {
                if (titleType === "COMPETITION") {
                    params = { ...params, leagueId: id };
                    let res;

                    if (this.currentSportType == "football") {
                        res = isFav
                            ? await this.unFavLeague(params)
                            : await this.addFavLeague(params);
                    } else if (this.currentSportType == "basketball") {
                        res = isFav
                            ? await this.unFavBasketballLeague(params)
                            : await this.addFavBasketballLeague(params);
                    }

                    this.toastrEvent(res, isFav, countryName, id, object);
                    this.$emit("doneFavToggle");
                } else if (titleType === "TEAM") {
                    params = { ...params, teamId: id };
                    let res;

                    if (this.currentSportType == "football") {
                        res = isFav
                            ? await this.unFavTeam(params)
                            : await this.addFavTeam(params);
                    } else if (this.currentSportType == "basketball") {
                        res = isFav
                            ? await this.unFavBasketballTeam(params)
                            : await this.addFavBasketballTeam(params);
                    }

                    this.toastrEvent(res, isFav, countryName, id, object);
                    this.$emit("doneFavToggle");
                } else if (titleType === "COUNTRY") {
                    if (this.country.isShowCountryListOnly) {
                        params = { ...params, leagueId: id };
                        let res;

                        if (this.currentSportType == "football") {
                            res = isFav
                                ? await this.unFavLeague(params)
                                : await this.addFavLeague(params);
                        } else if (this.currentSportType == "basketball") {
                            res = isFav
                                ? await this.unFavBasketballLeague(params)
                                : await this.addFavBasketballLeague(params);
                        }

                        this.toastrEvent(res, isFav, countryName, id, object);
                        this.$emit("doneFavToggle");
                    } else {
                        this.searchByCountry(id, countryName);
                    }
                }
            }
        },

        handleSearchUserInput() {
            this.userInput = this.$refs.userInputRef.value;
            if (this.userInput === "") {
                this.countryResult = "";
                this.getPopularData();
            } else {
                if (!this.isSearching) {
                    this.isSearching = true;
                    setTimeout(() => {
                        this.searchList(this.userInput);
                    }, 2000);
                }
                //this.$refs.favContentListRef.scrollTo(0,0)
            }
        },
        toastrEvent(res, isFav, countryName, id, object) {
            if (res.result.businessCode === -1) {
                object.isFav = !object.isFav;
            } else {
                let paramsToastr = {
                    isOpen: true,
                    msg: countryName,
                    isAddedFav: isFav ? false : true,
                };

                this.toastrFavChangeEvent(paramsToastr);

                if (this.tabName === "FILTER") {
                    //update home page match list
                    this.$emit("favModelEmit");
                }
            }
        },

        resetCountryDisplay() {
            this.country.isShowCountryListOnly = false;
            this.country.currentCountryDisplay = "";
            this.isNoCompetitionDataFromCountry = false;
        },
        handleCountryGoBack() {
            this.searchList(this.userInput);
        },
        handleEmptyResult(result) {
            if (result.result.length > 0) {
                this.isNoData = false;
            } else {
                this.isNoData = true;
            }
        },
        handleClearUserInput() {
            this.userInput = "";
            this.countryResult = "";
            this.getPopularData();
            this.$nextTick(() => {
                this.$refs.userInputRef.focus();
            });
        },
        handleContent(e) {
            e.stopPropagation();
        },
        handleFavContentScrollEvent(event) {
            if (this.isMobile) {
                //this.$refs.userInputRef.blur();
            } else {
                this.favLoginTipsChangeEvent({ isOpen: false });
            }
        },
        pageIsRedirected() {
            this.$emit("closeModal");
        },
        selectTab(item, tabs) {
            tabs.forEach((e) => {
                e.selected = false;
            });
            item.selected = true;
            this.tabsSelected = item.name;
        },
    },
};
</script>

<style scoped>
.fav-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(32, 32, 32, 0.75);
    z-index: 10;
}
.fav-modal__wrapper {
    background: var(--color-background-default-secondary);
    border-radius: 24px;
    width: 50rem;
    height: 31.5rem;
    padding: 2rem 0 4rem 0;
}
.fav-modal__inner-wrapper {
    width: calc(100% - 48px);
    margin: 0 24px;
    overflow: hidden;
    padding-right: 0.5rem;
}
.fav-modal__wrapper-list {
    width: 100%;
    max-height: 26rem;
    overflow-y: auto;
}
.search-wrapper {
    width: 100%;
    background-color: var(--color-background-default-secondary);
    border: 1px solid var(--color-border-default-default);
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    margin: 1rem 0 1rem 0;
}
.search-icon {
    margin-right: 8px;
}
.search-clear {
    width: 1.25rem;
    height: 1.25rem;
    background: #212b30;
    border-radius: 50%;
    cursor: pointer;
}
.fav-modal__subtitle {
    font-size: 16px;
    line-height: 1.25rem;
    margin: 1rem 0 0.625rem 0;
    font-family: var(--weight-600);
    color: var(--color-text-default-secondary);
    padding: 8px;
    border-radius: 8px;
    box-sizing: border-box;
}
.subtitle-countryOnly:hover {
    background-color: var(--color-background-default-secondary-hover);
}
/* .fav-modal__wrapper-list > div > div:first-child .fav-modal__subtitle {
  margin: .5rem 0 0.625rem 0;
} */
.fav-modal__modal-card-wrapper {
    gap: 0.5rem;
}
.fav-modal__close-wrapper {
    width: 94%;
    margin: 0 auto;
}
.fav-modal__close {
    background: url("../../../../static/images/icons/aspn_icon/icon_close.png")
        no-repeat center center;
    background-size: 100%;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
}
.fav-modal__wrapper-list::-webkit-scrollbar {
    width: 0.5rem;
    position: absolute;
}
.fav-modal__wrapper-list::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
}
.fav-modal__wrapper-list::-webkit-scrollbar-track {
    background: #ddd;
    border-radius: 4px;
}
.fav-modal__wrapper-list.scrollbar-show {
    padding-right: 0.25rem;
    width: calc(100% + 0.25rem);
}

.fav-model__back {
    margin-right: 0.9rem;
    display: flex;
    align-items: center;
}
.tab-list {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
}
.tab-item {
    padding: 8px 24px;
    font-family: var(--weight-600);
    font-size: 16px;
    border-radius: 24px;
    border: 1px solid var(--color-border-default-default);
    color: var(--color-text-default-default);
    cursor: pointer;
    letter-spacing: 0.64px;
}
.tab-item.selected {
    background-color: var(--color-background-brand-default);
    color: var(--color-button-active);
}
.loading-box {
    width: 100%;
    height: 400px;
    /* background: red; */
    display: flex;
    align-items: center;
    justify-content: center;
}
.fav-modal__subtitle.subtitle-countryOnly:hover {
    background-color: transparent;
}
@media(max-width: 768px) {
    /* for test */
    .fav-modal__wrapper {
        width: 100%;
        height: 100%;
        padding: unset;
        border-radius: 0;
    }
    .fav-modal__inner-wrapper {
        width: 100%;
        margin: 0;
        padding: unset;
    }
    .fav-modal__wrapper-list {
        max-height: 100vh;
        min-height: calc(100vh - 45.59px - 69px);
        background-color: var(--color-background-default-default);
        padding: 16px 8px;
        box-sizing: border-box;
        padding-bottom: 120px;
    }
    .fav-modal__wrapper-list::-webkit-scrollbar {
        width: 0;
    }
    .fav-modal__close {
        width: 1.5rem;
        height: 1.5rem;
        position: absolute;
        left: 1rem;
    }
    .fav-modal__close-wrapper {
        width: unset;
        padding: 0.5rem 1rem;
        position: relative;
    }
    .search-wrapper {
        height: 3rem;
        margin: 0.5rem auto;
        padding: 0.5rem 8px;
        border: 0;
        margin-bottom: 20px;
    }
    .fav-modal__subtitle {
        margin: 1rem 0;
        color: var(--color-text-default-default);
    }
    .fav-modal__close-title {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
    .fav-modal__btn-wrapper {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 5rem;
        background: #000;
    }
    .fav-modal__btn {
        background: #01c3f7;
        border-radius: 4px;
        padding: 0.625rem 0.75rem;
        border: none;
        font-family: var(--weight-700);
        width: 90%;
        color: black !important;
    }
    .has-btn {
        padding-bottom: 12rem;
    }
    .tab-list {
        gap: 4px;
        justify-content: center;
    }
    .tab-item {
        font-size: 13px;
        padding: 8px 16px;
    }
    .search-icon {
        margin-right: 10px;
    }
    .close-text {
        font-size: 16px;
        margin-right: 8px;
        font-family: var(--weight-700);
        color: var(--color-text-default-default);
        letter-spacing: 0.64px;
    }
    .fav-modal__wrapper-list > div > div .fav-modal__subtitle {
        margin: 0 0 16px 0;
    }
    .fav-modal__modal-card-wrapper {
        gap: 4px;
    }
    .fav-filter-container-box {
        border-radius: 16px;
        margin-bottom: 16px;
        padding: 8px 0 16px;
        background-color: var(--color-background-default-secondary);
    }
}
</style>
